export function handleRouterToPageMap(routerList) {
    let routerMap = {};
    let mList = [];
    function handleMap(list, parentItem) {
        if (list && list.length) {
            for (let item of list) {
                if (!parentItem) {
                    item.breadCrumb = [item.funcName];
                    item.menuKeys = [item.path];
                } else {
                    const parBreadCrumb = [...parentItem.breadCrumb];
                    const parMenuKeys = [...parentItem.menuKeys];
                    item.breadCrumb = [...parBreadCrumb, item.funcName];
                    item.menuKeys = [...parMenuKeys, item.path];
                }
                if (item.funcType === 'DIR') {
                    routerMap[item.path] = {
                        ...item,
                    };
                    mList.push(routerMap[item.path]);
                    handleMap(item.children, item);
                } else {
                    routerMap[item.path] = {
                        ...item,
                    };
                    mList.push(routerMap[item.path]);
                }
            }
        } else {
            return;
        }
    }
    handleMap(routerList);
    // console.log(mList, 'mList');
    return { routerMap, mList };
}

export function getDefaultPage(routerList) {
    let defaultPage = '';
    function handleList(list) {
        if (list && list.length) {
            for (let item of list) {
                if (defaultPage) {
                    return defaultPage;
                }
                if (item.funcType === 'DIR' && item.isShow) {
                    handleList(item.children);
                } else {
                    defaultPage = item.path;
                    return defaultPage;
                }
            }
        } else {
            return defaultPage;
        }
    }
    handleList(routerList);
    return defaultPage;
}
export function routerIsParamsOrQuery(route) {
    const { params, query } = route;
    // console.log(query, 'query');
    if (Object.keys(params).length || Object.keys(query).length) {
        let path = route.path;
        let originalPath = route.path;
        if (Object.keys(params).length) {
            const paramsLenght = Object.keys(params).length;
            const pathList = path.split('/').filter(v => v !== '');
            pathList.splice(pathList.length - paramsLenght);
            let orPath = '';
            pathList.forEach(item => {
                orPath += '/' + item;
            });
            if (orPath) {
                originalPath = orPath;
            }
        }
        const queryKeys = [];
        for (let key of Object.keys(query)) {
            if (!query[key]) {
                continue;
            }
            if (!queryKeys.length) {
                path += `?${key}=${query[key]}`;
                queryKeys.push(key);
            } else {
                path += `&${key}=${query[key]}`;
            }
        }
        // console.log(path, 'path');
        return { status: true, originalPath: originalPath, totalPath: path };
    }
    return { status: false, originalPath: route.path, totalPath: route.path };
}